module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/code-standard/code-standard.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/code-standard/code-standard.component.css
// module chunks = main